import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import AnimatedPage from "./AnimatedPage";

const IndiaAgiStats = ({ isAuthenticated }) => {
  const [visits, setVisits] = useState({});
  const [questions, setQuestions] = useState({});
  const [shares, setShares] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(
        "https://api.indiaagi.ai/counter/visitors"
      );
      setVisits(data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(
        "https://api.indiaagi.ai/counter/questions"
      );
      setQuestions(data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(
        "https://api.indiaagi.ai/counter/shares"
      );
      setShares(data);
    };
    fetchData();
  }, []);

  if (!isAuthenticated) {
    return <></>;
  }

  return (
    <AnimatedPage>
      <div className="flex w-full h-5/6 justify-center items-center">
        <table className="border m-5">
          <thead>
            <tr>
              <th className="text-center border">Item</th>
              <th className="text-center border">Today</th>
              <th className="text-center border">Yesterday</th>
              <th className="text-center border">Total so far</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className="text-center border">Visits</th>
              <td className="text-center border">{visits.today}</td>
              <td className="text-center border">{visits.yesterday}</td>
              <td className="text-center border">{visits.total}</td>
            </tr>
            <tr>
              <th className="text-center border">Questions</th>
              <td className="text-center border">{questions.today}</td>
              <td className="text-center border">{questions.yesterday}</td>
              <td className="text-center border">{questions.total}</td>
            </tr>
            <tr>
              <th className="text-center border">Shares</th>
              <td className="text-center border">{shares.today}</td>
              <td className="text-center border">{shares.yesterday}</td>
              <td className="text-center border">{shares.total}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </AnimatedPage>
  );
};

export default IndiaAgiStats;
